import React from 'react';
import { WizardStepName } from '../../../data/ppoints/constants';
import { WizardStepModel } from '../models/WizardStepModel';
import WizardStepItem from './WizardStepItem';

export const WizardBody: React.FC<WizardBodyProps> = (props) => {
    return (
        <div className="flex flex-col">
            {props?.steps?.map((step) => {
                return (
                    <WizardStepItem
                        stepProperties={step}
                        key={step.name}
                        open={!step.name ? false : props.openStepName === step.name}
                        locked={!step.name ? false : props.isStepLocked(step.name)}
                        onClick={props.handleStepToggle}
                    />
                );
            })}
        </div>
    );
};

type WizardBodyProps = {
    steps: WizardStepModel[] | null;
    openStepName: WizardStepName | null;
    isStepLocked: (stepName: WizardStepName) => boolean;
    handleStepToggle: (stepName: WizardStepName) => void;
};
